@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;
  position: relative;

  .fluid-container {
    height: 100%;
    max-height: 100%;

    // ==== Overflow

    $overflow-values: (
      visible: visible,
      hidden: hidden,
      scroll: auto  //  'auto' should ALWAYS be used instead of 'scroll'
    );

    @each $key, $value in $overflow-values {
      &.overflow-x-#{$key} {
        overflow-x: $value;
      }

      &.overflow-y-#{$key} {
        overflow-y: $value;
      }
    }

    // ==== Padding

    @each $key, $value in $spacing-sizes {
      &.padding-#{$key} {
        padding-top: $value;
        padding-bottom: $value;
        padding-left: $value;
        padding-right: $value;
      }
    }

    // ==== Text Alignment

    &.text-align-left {
      text-align: left;
    }

    &.text-align-center {
      text-align: center;
    }

    &.text-align-right {
      text-align: right;
    }

    // ==== Background Color

    &.background-color-transparent {
      background-color: transparent;
    }

    &.background-color-atmospheric {
      background-color: $liberty-gray-4;
    }

    &.background-color-white {
      background-color: $white;
    }
  }

  // ==== Fixed Content Slots

  .fixed-content-top,
  .fixed-content-bottom {
    position: absolute;
    left: 0;
    right: 0;
  }

  .fixed-content-left,
  .fixed-content-right {
    position: absolute;
    top: 0;
    bottom: 0;
  }

  .fixed-content-top {
    top: 0;
  }

  .fixed-content-bottom {
    bottom: 0;
  }

  .fixed-content-left {
    left: 0;
  }

  .fixed-content-right {
    right: 0;
  }
}

// ==== Inline Container

:host(.fluid-container--inline) {
  display: inline-block;
  vertical-align: top;
}

// ==== Width / Height (applied to "host" element)

$size-values: (
  xxs: 5%,
  xs: 10%,
  sm: 25%,
  md: 50%,
  lg: 75%,
  xl: 90%,
  full: 100%
);

@each $key, $value in $size-values {
  :host(.width-#{$key}) {
    width: $value;
  }

  :host(.min-width-#{$key}) {
    min-width: $value;
  }

  :host(.max-width-#{$key}) {
    max-width: $value;
  }

  :host(.height-#{$key}) {
    height: $value;
  }

  :host(.min-height-#{$key}) {
    min-height: $value;
  }

  :host(.max-height-#{$key}) {
    max-height: $value;
  }
}

// ==== Margin (applied to "host" element)

@each $key, $value in $spacing-sizes {
  :host(.margin-#{$key}) {
    margin-top: $value;
    margin-bottom: $value;
    margin-left: $value;
    margin-right: $value;
  }
}
